export const error = state => state.error
export const violations = state => state.violations
export const isLoading = state => state.isLoading
export const items = state => state.items

export const isLoadingAll = state => state.isLoadingAll
export const allItems = state => state.allItems
